@use "../../../../src/styles/Colors.scss" as Colors;
@use "../../../../src/styles/Constants.scss" as Constants;

.icon {
	width: Constants.$val-spacing-l;
	align-self: center;
	justify-content: center;
	font-size: Constants.$val-icon16,
}

.container {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;

	&__padded {
		padding: Constants.$val-spacing-l Constants.$val-spacing-s;
	}
}

.pwRequirementsElement {
	p {
		margin: 0;
	}

	padding: Constants.$val-spacing-s 0;
}

.pwRequirementsContainer {
	display: flex;
 	align-items: center;

	p {
		margin: 0;
	}
}

.textGrey {
	color: Colors.$col-design-grey13 !important;
}

.submitButton {
	margin: 0 Constants.$val-spacing-xxxl;
}


.marginBottom {
	margin-bottom: Constants.$val-spacing-s;
}